define([], function resourceEnumerateModule() {
  'use strict';
  var resourceEnumerate = function(requestOptions) {
    return {
      apis: {
        readingIq: {
          url: `${location.protocol}//${
            location.hostname
          }/ws/private/0.1/json/Resource/Enumerate/init`,
          requestOptions: requestOptions,
          localConfigKey: function localConfigKey() {
            return 'local';
          },
          stageConfigKey: function stageConfigKey() {
            return 'stage';
          },
          localReplace: function localReplace() {
            return {
              protocol: 'https://',
              hostname: location.hostname,
              api: 'private'
            };
          },
          stageReplace: function stageReplace() {
            return {
              protocol: location.protocol + '//',
              hostname: location.hostname,
              api: 'private'
            };
          },
          invalidateCache: function invalidateCache() {
            return false;
          }
        },
        marketing: {
          url: `${location.protocol}//${
            location.hostname
          }/ws/marketing/0.1/json/Resource/Enumerate/init`,
          requestOptions: requestOptions,
          localConfigKey: function localConfigKey() {
            return 'local';
          },
          stageConfigKey: function stageConfigKey() {
            return 'stage';
          },
          localReplace: function localReplace() {
            return {
              protocol: 'https://',
              hostname: location.hostname,
              api: 'marketing'
            };
          },
          stageReplace: function stageReplace() {
            return {
              protocol: location.protocol + '//',
              hostname: location.hostname,
              api: 'marketing'
            };
          },
          invalidateCache: function invalidateCache() {
            return false;
          }
        }
      },
      localRegex: /localhost|\d\.\d/,
      stageRegex: /r7q.io/,
      localConfigPath: 'js/config/local-api-config.json',
      stageConfigPath: 'js/config/stage-api-config.json'
    };
  };
  return resourceEnumerate;
});
